import { gql } from "@apollo/client";
export const FindCurrencies = gql `
  query Query {
    FindCurrencies
  }
`;
